import { ContentList } from "../../../../screens/MapScreen";
import ContentTitle from "../ContentTitle";
import WideButton from "./WideButton";
import styles from "./AddPlace.module.css";
import BottomButtonBox from "../../BottomButtonBox";
import { MiniButtonType } from "../../MiniButton";

interface AddPlaceProps {
    changeContent: (type: ContentList, reset?: boolean) => void;
}

/**
 * 신규 장소 등록 선택 화면
 * @author mjkang
 * @date 2024-09-12 10:14:32
 * @param props: AddPlaceProps
 * @props changeContent: 사이드 시트 콘텐츠를 변경하는 함수
 */
const AddPlace = (props: AddPlaceProps) => {
    const addSinglePlace = () => {
        props.changeContent(ContentList.AddSinglePlace);
    };

    const addMultiplePlaces = () => {
        props.changeContent(ContentList.AddMultiplePlaces);
    };

    const cancel = () => {
        props.changeContent(ContentList.Back, true);
    };

    const buttonOptions = {
        single: {
            title: "신규 장소 추가하기",
            desc: "새로운 장소 한 곳을 추가할 수 있어요.",
            onClick: addSinglePlace,
        },
        multiple: {
            title: "신규 장소 일괄 추가하기",
            desc: "엑셀 혹은 csv 파일을 업로드하여 한 번에 여러 개의 장소를 추가할 수 있어요.",
            onClick: addMultiplePlaces,
        },
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.top}>
                <ContentTitle title={"신규 장소 등록"} />
                <div className={styles.desc}>{" 📍 지도에 새로운 장소를 추가해주세요."}</div>
                <WideButton {...buttonOptions.single} />
                {<div className={styles.buttonWrapper}>
                    <WideButton {...buttonOptions.multiple} />
                </div>}
            </div>
            <div className={styles.bottom}>
                <BottomButtonBox right={{ label: "취소", type: MiniButtonType.GRAY, onClick: cancel }} />
            </div>
        </div>
    );
};

export default AddPlace;
